import { Moon, Sun, Monitor, Heart, Snowflake } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useUserSettingsContext } from "@/contexts/UserSettingsContext";

const themeConfig = [
  {
    id: "light",
    name: "Light",
    icon: Sun,
  },
  {
    id: "dark",
    name: "Dark",
    icon: Moon,
  },
  {
    id: "system",
    name: "System",
    icon: Monitor,
  },
  {
    id: "pink",
    name: "Pink",
    icon: Heart,
  },
  {
    id: "ice-blue",
    name: "Ice Blue",
    icon: Snowflake,
  },
];

interface ThemeDropdownProps {
  size?: "sm" | "default";
  showLabel?: boolean;
}

export const ThemeDropdown = ({
  size = "default",
  showLabel = false,
}: ThemeDropdownProps) => {
  const { theme, updateTheme } = useUserSettingsContext();

  const currentTheme =
    themeConfig.find((t) => t.id === theme) || themeConfig[2];
  const CurrentIcon = currentTheme.icon;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size={size}
          className={size === "default" ? "h-10 w-10 p-0" : undefined}
          title="Toggle theme"
        >
          <CurrentIcon className={size === "default" ? "h-5 w-5" : "h-4 w-4"} />
          {showLabel && <span className="ml-2">{currentTheme.name}</span>}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        {themeConfig.map((themeOption) => {
          const Icon = themeOption.icon;
          return (
            <DropdownMenuItem
              key={themeOption.id}
              onClick={() => updateTheme(themeOption.id)}
              className="flex items-center space-x-2"
            >
              <Icon className="h-4 w-4" />
              <span>{themeOption.name}</span>
              {theme === themeOption.id && (
                <div className="ml-auto h-2 w-2 rounded-full bg-primary" />
              )}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
